import React from 'react';
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from 'recharts';

const mockData = [
  { month: 'Jan', mrr: 1200, arr: 14400, churn: 50 },
  { month: 'Feb', mrr: 1250, arr: 15000, churn: 30 },
  { month: 'Mar', mrr: 1300, arr: 15600, churn: 40 },
  { month: 'Apr', mrr: 1400, arr: 16800, churn: 20 },
  { month: 'May', mrr: 1450, arr: 17400, churn: 10 },
  { month: 'Jun', mrr: 1500, arr: 18000, churn: 0 },
  { month: 'Jul', mrr: 1550, arr: 18600, churn: 0 },
  { month: 'Aug', mrr: 1600, arr: 19200, churn: 0 },
  { month: 'Sep', mrr: 1620, arr: 19440, churn: 0 },
  { month: 'Oct', mrr: 1650, arr: 19800, churn: 0 },
  { month: 'Nov', mrr: 1700, arr: 20400, churn: 0 },
  { month: 'Dec', mrr: 1750, arr: 21000, churn: 0 },
];

interface RevenueChartProps {
  loading?: boolean;
  data?: any[];
}

const RevenueChart: React.FC<RevenueChartProps> = ({ loading, data }) => {
  const chartData = data && data.length > 0 ? data : mockData;
  return (
    <div className="bg-white rounded-xl shadow p-6 h-96 flex flex-col">
      <h3 className="text-lg font-bold mb-4">Crescimento de Receita (MRR/ARR)</h3>
      {loading ? (
        <div className="w-full h-full bg-gray-100 animate-pulse rounded-lg" />
      ) : (
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={chartData} margin={{ top: 16, right: 24, left: 0, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="month" />
            <YAxis />
            <Tooltip />
            <Line type="monotone" dataKey="mrr" stroke="#10B981" strokeWidth={2} name="MRR" />
            <Line type="monotone" dataKey="arr" stroke="#3B82F6" strokeWidth={2} name="ARR Projetado" />
            <Line type="monotone" dataKey="churn" stroke="#EF4444" strokeWidth={2} name="Churn" dot={false} strokeDasharray="5 5" />
          </LineChart>
        </ResponsiveContainer>
      )}
    </div>
  );
};

export default RevenueChart; 